export enum PulseConversationContentOrigin {
  Api = 'api',
  Smtp = 'smtp',
}
